// src/pages/admin/UsersPage.jsx

import React from "react";
import UsersList from "../../components/admin/UsersList";

const UsersPage = () => {
  return (
    <div>
      <UsersList />
    </div>
  );
};

export default UsersPage;
